<template>
  <div class="taskAdd">
    <Header title="任务发布"></Header>
    <!-- <NOdata title="功能暂未开放~"></NOdata>    -->
    <div class="apply">
      <van-field v-model="rwbh" label="任务编号" placeholder="请输入任务编号" />
      <van-field
        v-model="rwlx.mc"
        label="任务类型"
        right-icon="arrow"
        input-align="right"
        placeholder="请点击选择"
        @click="showPop('任务类型', 'rwlx')"
        readonly
      />
      <van-field
        v-model="sxxm.mc"
        label="实习项目"
        right-icon="arrow"
        input-align="right"
        placeholder="请点击选择"
        @click="showPop('实习项目', 'sxxm')"
        readonly
      />
      <div v-if="rwlx.dm == 0" class="top-btn">
        <button @click="addTask">增加任务</button>
      </div>
      <div class="task">
        <span v-for="(item, index) in task" :key="index">
          <div v-if="item.isShow" class="task-card">
            <p><van-field v-model="item.bt" placeholder="请输入标题" /></p>
            <van-field v-model="item.nr" rows="4" autosize type="textarea">
              <template #button>
                <van-button size="small" type="primary" @click="del(index)"
                  >删除</van-button
                >
              </template>
            </van-field>
          </div>
        </span>
      </div>
    </div>
    <div class="bottom-btn">
      <span>
        <button @click="save()">发布</button>
      </span>
    </div>
    <van-popup v-model="show" round position="bottom">
      <van-picker
        :title="valueList.label"
        show-toolbar
        :columns="valueList.item"
        @cancel="show = false"
        @confirm="
          (value, index) => {
            onConfirm(value, index, valueList.value);
          }
        "
      />
    </van-popup>
  </div>
</template>

<script>
import { Api } from "@/utils/axios";

export default {
  data() {
    return {
      task: [],
      rwbh: "",
      show: false,
      rwlx: {
        mc: "周任务",
        dm: "0"
      },
      sxxm: {},
      valueList: {
        label: "",
        value: "",
        item: []
      },
      flag: 0,
      columns: {}
    };
  },
  mounted() {
    this.task[0].isShow = true;
  },
  created() {
    this.getList();
    for (let i = 0; i < 30; i++) {
      this.task.push({
        bt: "第" + (i + 1) + "周任务",
        nr: "",
        isShow: false
      });
    }
  },
  methods: {
    del(index) {
      this.task[index].isShow = false;
    },
    async save() {
      if (this.rwbh == "" || this.sxxm.dm == undefined) {
        this.$toast.fail("请填写完整");
        return;
      }
      let btarr = [];
      let nrarr = [];
      var regEn = /#/im;
      for (let item of this.task) {
        if (item.isShow == true) {
          if (item.bt == "" || item.nr == "") {
            this.$toast.fail("请填写完整任务");
            return;
          }
          if (regEn.test(item.bt) || regEn.test(item.nr)) {
            this.$toast.fail("输入的内容请勿带#");
            return;
          }
          btarr.push(item.bt);
          nrarr.push(item.nr);
        }
      }
      const res = await Api.sxrwfbsave({
        sj0607id: this.sxxm.dm,
        lx: this.rwlx.dm,
        rwbh: this.rwbh,
        bt: btarr.join("#"),
        rwnr: nrarr.join("#")
      });

      if (res.code == "1") {
        this.$toast.success("发布成功");
        setTimeout(() => {
          this.$router.replace({
            path: "/taskAdd/index"
          });
        }, 1500);
      } else {
        return;
      }
    },
    addTask() {
      this.flag++;
      this.task[this.flag].isShow = true;
    },
    async getList() {
      const res = await Api.getrwfbxx();
      this.columns.sxxm = res.data.map(item => {
        return {
          value: item.sj0607id,
          text: item.xmmc
        };
      });
      this.columns.rwlx = [
        {
          text: "周任务",
          value: "0"
        },
        {
          text: "一次性任务",
          value: "1"
        }
      ];
    },
    // 弹出选择器
    showPop(label, value) {
      this.show = true;
      this.valueList.label = label;
      this.valueList.value = value;
      this.valueList.item = this.columns[value];
    },
    onConfirm(value, index, value1) {
      this.show = false;
      this[value1].mc = value.text;
      this[value1].dm = value.value;
    }
  }
};
</script>
<style lang="less" scoped>
.taskAdd {
  .apply {
    padding: 0 20px;
    height: 80vh;

    .task {
      padding-top: 20px;
      height: 55vh;
      overflow: auto;
      .task-card {
        // display: none;
        padding: 20px;
        background: #f8f8f8;
        border-radius: 5px;
        margin-bottom: 5%;
      }
      p {
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #212f6e;
        letter-spacing: 0;
        font-weight: bolder;
        margin-bottom: 10px;
      }
    }
  }
  .top-btn {
    box-sizing: border-box;
    width: 100%;
    height: 60px;
    padding: 20px 5% 10px 5%;
    background: #fff;

    button {
      width: 100%;
      height: 44px;
      background: #ecedfd;
      border-radius: 3px;
      color: #7469f8;
    }
    // span {
    //   display: inline-flex;
    //   justify-content: space-between;
    //   width: 100%;
    //   button:first-child {
    //     width: 45%;
    //     height: 44px;
    //     background: #ecedfd;
    //     border-radius: 3px;
    //     color: #7469f8;
    //   }
    //   button:last-child {
    //     width: 45%;
    //     height: 44px;
    //     background: #7469f8;
    //     border-radius: 3px;
    //     color: #fff;
    //   }
    //   .single {
    //     width: 100% !important;
    //   }
    // }
  }
}
.bottom-btn {
  box-sizing: border-box;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 60px;
  padding: 0 5% 10px 5%;
  background: #fff;

  button {
    width: 100%;
    height: 44px;
    background: #7469f8;
    border-radius: 3px;
    color: #fff;
  }
  // span {
  //   display: inline-flex;
  //   justify-content: space-between;
  //   width: 100%;
  //   button:first-child {
  //     width: 45%;
  //     height: 44px;
  //     background: #ecedfd;
  //     border-radius: 3px;
  //     color: #7469f8;
  //   }
  //   button:last-child {
  //     width: 45%;
  //     height: 44px;
  //     background: #7469f8;
  //     border-radius: 3px;
  //     color: #fff;
  //   }
  //   .single {
  //     width: 100% !important;
  //   }
  // }
}
</style>
<style lang="less">
.taskAdd {
  .apply {
    .van-cell {
      border-bottom: 1px solid #f4f4f4;
    }
    .van-cell::after {
      display: none;
    }
    .van-field__label {
      width: 7.2em;
      span {
        width: 96px !important;
        display: inline-block;
      }
    }
    .van-cell.van-field .van-cell__title.van-field__label > span {
      font-family: PingFangSC-Light;
      font-size: 16px;
      color: #212f6e;
      letter-spacing: 0;
    }
    .van-field__control::-webkit-input-placeholder {
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #dfe0e6 !important;
      letter-spacing: 0;
      font-weight: normal;
      text-align: right;
    }
    .van-field__control::-moz-input-placeholder {
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #dfe0e6 !important;
      font-weight: normal;
      letter-spacing: 0;
      text-align: right;
    }
    .van-field__control::-ms-input-placeholder {
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #dfe0e6 !important;
      letter-spacing: 0;
      font-weight: normal;
      text-align: right;
    }
    .van-field__control {
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #212f6e;
      letter-spacing: 0;
      text-align: right;
      font-weight: bolder;
    }
    .van-icon-arrow {
      color: #dfe0e6;
      font-weight: bolder;
      font-size: 14px;
    }
    .van-cell__title,
    .van-cell.van-field .van-cell__title.van-field__label > span {
      width: 64px;
      height: 22px;
      font-family: PingFangSC-Light;
      font-size: 16px;
      color: #212f6e;
      letter-spacing: 0;
    }
    .van-field__control::-webkit-input-placeholder {
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #dfe0e6 !important;
      letter-spacing: 0;
      text-align: right;
    }
    .van-field__control::-moz-input-placeholder {
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #dfe0e6 !important;
      letter-spacing: 0;
      text-align: right;
    }
    .van-field__control::-ms-input-placeholder {
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #dfe0e6 !important;
      letter-spacing: 0;
      text-align: right;
    }
  }
}
.task .van-cell:first-child {
  padding: 0 !important;
  background-color: transparent !important;
}
.task .van-field__control {
  text-align: left !important;
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/teacher/taskAdd/taskAdd.vue